// rerouter.js — run this before page content on every page
const EXCLUDED_PATHS = ['tdt2021', 'tdt2022', 'atea', 'clover', 'sp-buttons', 'instant-payment'];

const GATEWAY = `https://${process.env.BACKEND_API_ENDPOINT}`;

function waitForLoader() {
  return new Promise((resolve) => {
    const el = document.getElementById('html-loader');
    if (el) return resolve(el);

    const observer = new MutationObserver(() => {
      const found = document.getElementById('html-loader');
      if (found) {
        observer.disconnect();
        resolve(found);
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
}

async function slugRedirection() {
  const loader = await waitForLoader();

  const slugName = window.location.pathname.split('/').filter(Boolean).pop() || '';
  if (!slugName || slugName.endsWith('.html')) {
    // Remove loader if no redirection needed
    loader.style.display = 'none';
    document.body.style.overflow = '';
    return;
  }
  if (EXCLUDED_PATHS.some(p => slugName.toLowerCase().includes(p))) {
    // Remove loader if path is excluded
    loader.style.display = 'none';
    document.body.style.overflow = '';
    return;
  }

  try {
    const response = await fetch(`${GATEWAY}/v1/account-slug/slug/${slugName}`);
    const data = await response.json();
    const redirectUri = data?.entity?.spObjectUrl;
    
    if (redirectUri) {
      // Let the loader remain visible during redirect
      window.location.href = redirectUri;
    } else {
      // Remove loader and redirect to invalid-slug page
      loader.style.display = 'none';
      document.body.style.overflow = '';
      location.replace('/invalid-slug.html');
    }
  } catch (error) {
    // Remove loader if there's an error
    loader.style.display = 'none';
    document.body.style.overflow = '';
    console.error('Slug redirection error:', error);
    // Continue with normal page load
  }
}

export default slugRedirection;
